import { Routes } from '@angular/router';

export const DASHBOARD_PATHS = {
  BASE: 'dashboard'
};

export const DashboardRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('@core/layout/main-layout/main-layout').then((m) => m.MainLayout),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/dashboard/dashboard.page').then((m) => m.DashboardPage)
      },
      {
        path: 'discovery',
        loadComponent: () => import('./pages/discovery/discovery.page').then((m) => m.DiscoveryPage),
        data: { hideHeader: true, hideBreadcrumbs: true }
      },
      {
        path: 'menu-builder',
        loadComponent: () => import('./pages/creating-menu/creating-menu.page').then((m) => m.CreatingMenuPage),
        data: { hideHeader: true, hideBreadcrumbs: true }
      },
      {
        path: 'order-management',
        loadComponent: () => import('./pages/order-mgmt/order-mgmt.page').then((m) => m.OrderManagementPage),
        data: { hideHeader: true, hideBreadcrumbs: true }
      },
      {
        path: 'producer-success',
        loadComponent: () => import('./pages/success/success.page').then((m) => m.SuccessPage),
        data: { hideHeader: true, hideBreadcrumbs: true }
      }
    ]
  }
];
